import React from 'react';
import { EventTextProps } from './EventText';
import { useSelector } from 'react-redux';
import { selectMatchEvents } from '../../features/match/matchSlice';
import { FormattedMessage } from 'react-intl';
import { getConnectedPenaltySaveEvent } from '../../helpers/getConnectedEvent';
import { MatchEventStatus } from '../../enums/matchEventStatus';

const EventTextPenaltyMiss: React.FC<EventTextProps> = ({ matchEvent }) => {
  const matchEvents = useSelector(selectMatchEvents);

  const team = matchEvent?.team?.name;
  const player = matchEvent?.person?.name;

  let penaltySaveEvent = getConnectedPenaltySaveEvent(matchEvents, matchEvent);

  if (penaltySaveEvent?.internal?.status === MatchEventStatus.DELETING) {
    penaltySaveEvent = undefined;
  }

  const penaltySavePlayerName = penaltySaveEvent?.person?.name;

  if (penaltySaveEvent) {
    if (player) {
      return (
        <FormattedMessage
          id="eventText.penaltySave"
          values={{
            player,
            team,
            penaltySavePlayerName,
          }}
        />
      );
    } else {
      return (
        <FormattedMessage
          id="eventText.penaltySave.noPlayer"
          values={{
            team,
            penaltySavePlayerName,
          }}
        />
      );
    }
  } else {
    return (
      <FormattedMessage
        id="eventText.penaltyMiss"
        values={{
          player,
          team,
        }}
      />
    );
  }
};

export default EventTextPenaltyMiss;
